export { HojeadorModule } from './hojeador.module';
export { HojeadorComponent } from './hojeador.component';
export { collapsible } from './collapsible.animation';
export * from './interfaces';
